
<div>
  <PageHeader
    v-if="isAuthenticated"
    :currentApp="$store.getters.getCurrentApp"
  />
  <SubNav v-if="isAuthenticated" />
  <router-view v-if="isAuthenticated" />
  <div
    v-if="visibleBanner"
    class="alert alert-dark text-center mb-0 banner browserWarning"
    role="alert"
  >
    OBS: Verktyget är optimerat för Chrome browser
    NOTE: This tool is optimized for Chrome browser

    <button
      type="button"
      class="btn btn-primary btn-sm ms-3 browserBannerBtn"
      @click="hideBrowserBanner()"
    >
      OK
    </button>
  </div>
</div>
